const countryCodes = ['AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE', 'GB'];

const shouldCollect = (countryCode)=>{
  return countryCodes.indexOf(countryCode) >= 0;
}

export default {
  countryCodes,
  shouldCollect
}